import { render, staticRenderFns } from "./accordionBlock.vue?vue&type=template&id=24452ec7&scoped=true"
import script from "./accordionBlock.vue?vue&type=script&lang=js"
export * from "./accordionBlock.vue?vue&type=script&lang=js"
import style0 from "./accordionBlock.vue?vue&type=style&index=0&id=24452ec7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24452ec7",
  null
  
)

export default component.exports